var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpVoteOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41663 6.37508L12.625 1.16675M12.625 1.16675L17.8333 6.37508M12.625 1.16675V13.6667C12.625 14.7718 12.186 15.8316 11.4046 16.613C10.6232 17.3944 9.56336 17.8334 8.45829 17.8334H1.16663",
    stroke: "#3373EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpVoteOn);
export default __webpack_public_path__ + "static/media/up-vote-on.c6cd8d2fd03283312631861eb3e9b8c5.svg";
export { ForwardRef as ReactComponent };